var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewApplicant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2.25H7.81C4.17 2.25 2 4.42 2 8.06V16.44C2 19.25 3.29 21.18 5.56 21.91C6.22 22.14 6.98 22.25 7.81 22.25H16.19C17.02 22.25 17.78 22.14 18.44 21.91C20.71 21.18 22 19.25 22 16.44V8.06C22 4.42 19.83 2.25 16.19 2.25ZM20.5 16.44C20.5 18.58 19.66 19.93 17.97 20.49C17 18.58 14.7 17.22 12 17.22C9.3 17.22 7.01 18.57 6.03 20.49H6.02C4.35 19.95 3.5 18.59 3.5 16.45V8.06C3.5 5.24 4.99 3.75 7.81 3.75H16.19C19.01 3.75 20.5 5.24 20.5 8.06V16.44Z",
    fill: "#576EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.25C10.0199 8.25 8.41992 9.85 8.41992 11.83C8.41992 13.81 10.0199 15.42 11.9999 15.42C13.9799 15.42 15.5799 13.81 15.5799 11.83C15.5799 9.85 13.9799 8.25 11.9999 8.25Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewApplicant);
export default __webpack_public_path__ + "static/media/new-applicant.7716c2ebc78561a58b54312667e66f63.svg";
export { ForwardRef as ReactComponent };